import { Component, Prop, Vue } from 'vue-property-decorator';
import { store } from '@/store/store';

@Component
export default class SectionTitle extends Vue {
  @Prop({ required: true }) public label!: string;
  @Prop({ default: '', required: false }) public routeNameTo!: string;

  protected get isIdentified(): boolean {
    return store.state.isIdentified;
  }
  protected get isAuthenticated(): boolean {
    return store.state.isIdentified;
  }

}

